<template>
  <div class="footer">
    <div class="foot-page">
      <div class="foot-page__left">
        <div>
          一起® | 一起题库 Copyright © 2011-2021 Shanghai Hexu Information Technology Co.,Ltd. All Rights Reserved.
        </div>
        <div>沪网文(2018)4978-332号 ICP证沪B2-20150026 沪ICP备13031855号-2</div>
        <div>
          <img src="@/assets/svg/Bitmap.png" alt="" />
          沪公网安备 31011202012902 号
        </div>
        <div>客服电话 ：4001601717</div>
        <div>反馈邮箱：yiqitiku@17zuoye.com</div>
      </div>
      <div class="foot-page__right">
        <div class="foot-page__right__left">
          <div><a target="_blank" href="//17zuoye.com/help/aboutus.vpage">关于我们</a></div>
          <div><a target="_blank" href="//17zuoye.com/help/news/index.vpage">新闻中心</a></div>
          <div><a target="_blank" href="//17zuoye.com/help/jobs.vpage">诚聘英才</a></div>
          <div>
            <a target="_blank" href="//17zuoye.com/project/educationsubject/list.vpage">课题相关</a>
          </div>
          <div>
            <a target="_blank" href="//17zuoye.com/help/privacyprotection.vpage">隐私保护</a>
          </div>
        </div>
        <div class="foot-page__right__mid">
          <div>
            <a target="_blank" href="//school.17zuoye.com/pcview/teacher/teacherofcourse/index">
              一教一学
            </a>
          </div>
          <div>
            <a
              target="_blank"
              href="https://baike.baidu.com/item/%E4%B8%80%E8%B5%B7%E4%BD%9C%E4%B8%9A/8691194?fr=aladdin"
            >
              一起作业
            </a>
          </div>
        </div>
        <div class="foot-page__right__right">
          <div class="qr-code" v-for="(item, index) in qrcodes" :key="index">
            <div class="qr-code-img">
              <img width="90px" :src="item.url" alt="" />
            </div>
            <div class="qr-code-title">
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="foot-desc">
      本网部分资源来源于互联网共享或个人上传，不确保部分用户上传资料的来源及知识产权归属，除本网组织的资源外，版权归原作者所有，如有侵犯版权，请立刻和本网联系，本网将核实后及时处理。
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    msg: String
  },
  data() {
    return {
      qrcodes: [
        {
          title: '一起题库',
          url: '//cdn-cnc.17zuoye.cn/fs-resource/601378513cb75ebeb8533475.jpeg'
        },
        {
          title: '一起题库服务号',
          url: '//cdn-cnc.17zuoye.cn/fs-resource/611b87e982393fe6e74669c7.jpeg'
        },
        {
          title: '一起题库小程序',
          url: '//cdn-cnc.17zuoye.cn/fs-resource/611b87e53cb75ec948a952ff.jpeg'
        }
      ]
    }
  }
}
</script>
<style scoped lang="scss">
.footer {
  width: 100%;
  position: relative;
}
.foot-desc {
  position: absolute;
  bottom: 0px;
  width: 100%;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.45);
}
.foot-page {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  padding: 17px;
  height: 100%;
  &__left {
    flex: 678;
    flex-shrink: 0;
    border-right: 1px solid #e9ebf2;
    height: 100%;
    > div {
      padding-left: 90px;
      text-align: left;
      line-height: 20px;
      font-size: 12px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.45);
    }
  }
  &__right {
    flex: 761;
    flex-shrink: 0;
    display: flex;
    &__left {
      width: 123px;
      div {
        margin-left: 52px;
        width: 80px;
        list-style: none;
        padding: 2px 8px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
        a {
          display: block;
          width: 100%;
          height: 100%;
          &:hover {
            background-color: $--color-bg;
            border-radius: 2px;
          }
        }
      }
    }
    &__mid {
      div {
        width: 80px;
        list-style: none;
        padding: 2px 8px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
        a {
          display: block;
          width: 100%;
          height: 100%;
          &:hover {
            background-color: $--color-bg;
            border-radius: 2px;
          }
        }
      }
    }
    &__right {
      .qr-code {
        display: inline-block;
        width: 90px;
        margin-right: 20px;
        .qr-code-img {
          width: 90px;
          height: 90px;
          background-color: $--color-bg;
        }
        .qr-code-title {
          margin-top: 8px;
          color: rgba(0, 0, 0, 0.45);
          font-weight: 400;
          font-size: 12px;
          line-height: 20px;
        }
      }
    }
  }
  a {
    color: rgba(0, 0, 0, 0.65);
  }
  text-align: center;
}
</style>
